import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
// import CountdownTimer from '../CountdownTimer';
// import AOS from 'aos';
// import "aos/dist/aos.css";
// import VisibilitySensor from 'react-visibility-sensor';
import { useElementOnScreen } from "../../hooks/useElementOnScreen";
import Menubar from "../MenuBarWebcast";
import Lazyload from "react-lazy-load";
import HubspotForm from "react-hubspot-form";
import ReadMoreContent from "./ReadMoreContent";

const VantageFitWebcastLive = (props) => {
    const [link, setlink] = useState("");
    const [showVideo, setshowVideo] = useState(false);

    const [containerRef, isVisible] = useElementOnScreen({
        root: null,
        threshold: 0,
        rootMargin: "0px",
    });

    // useEffect(() => {
    //     AOS.init({
    //         duration : 2000
    //       });
    // }, [])

    useEffect(() => {
        console.log("visible");
    }, [isVisible]);

    const anjanText = `As the CTO and Co-Founder of the company, Anjan Pathak is responsible for the technological progress and evolution of <span style="font-weight: 600">Vantage Circle</span>. As a wellness and fitness enthusiast and an athlete holding the prestigious "Iron Man" title, he spearheaded the development of Vantage Fit to promote total employee well-being across organizations.`;
    const speaker1Text = `Himanshu Ajay Jain, the co-founder and wellbeing lead at <span style="font-weight: 600">MantraCare</span>, has over 13 years of experience working with multiple organizations to address issues of employee stress, burnout, and anxiety. He has spearheaded the end-to-end launch of employee assistance programs at more than 10 corporations. He has worked in more than eight countries to help Fortune 500 companies improve employee efficiency and motivation levels via structured interventions.`;

    return (
        <>
            <header className="mb-2 py-0 pt-2 nav-black" id="headerarea">
                <div className="my-lg-auto px-lg-3 container mx-auto">
                    <div className="row">
                        <div className="col-12 mx-lg-auto my-auto pt-2 text-center">
                            <a
                                href="/vantage-fit-webcast-registration/"
                                className="navbar-brand sticky_logo"
                            >
                                <img
                                    width="210"
                                    height="45"
                                    className="site-logo img-responsive mx-auto vfit-img"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                                    alt="Vantage Fit Logo"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </header>
            <section
                className="col-12 py-5 hero-bg webcast webcast-live"
                style={{ overflowX: "hidden" }}
            >
                <div className="container col-12">
                    <div className="col-lg-12">
                        <div className="row align-items-center justify-content-center">
                            <div
                                className="col-12 position-relative text-center"
                                style={{ padding: "0" }}
                            >
                                <div className="webcast-label">
                                    <div className="mx-auto">
                                        Celebrating Mental Health Awareness at
                                        Work
                                    </div>
                                </div>
                                <img
                                    className="position-relative py-3 mb-3 img-responsive mx-auto vfit-img"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/w_350/v1679479914/VantageFit/2023/vantagefit-webcast-negative_logo.png"
                                    alt="Vantage Fit Webcast Logo"
                                />

                                {/* <p style={{ color: '#fff', fontSize: '18px', marginBottom: '0'}}>#WorldHealthDay</p> */}
                                <h1
                                    className="sectionTitle-left font-weight-bold"
                                    style={{ paddingTop: "0" }}
                                >
                                    Mental Health at Work: Embracing a Positive
                                    View
                                </h1>
                                {/* <p className='sub-para text-center'>Effective and successful communication is an essential skill many find difficult to master. Effectively communicating allows employees to express their feelings and thoughts constructively, but being unable to do so creates misunderstanding and conflict, leading to poor mental health. In this episode, we will discuss how HR managers can celebrate World Health Day by implementing effective communication strategies to foster a supportive and healthy work environment. </p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="col-12 py-lg-5 text-center">
                <iframe
                    className="webcast-iframe my-4"
                    src="https://www.youtube.com/embed/qUHVTdd8iBg"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
            </section>

            <section className="col-12 py-lg-5 text-center">
                <a href="https://www.vantagefit.io/casestudy/" target="_blank">
                    <img
                        className="img-responsive mx-auto vfit-img"
                        src="https://res.cloudinary.com/vantagecircle/image/upload/w_1000/v1680594313/VantageFit/2023/case-studies-vfit.png"
                        alt="Vantage Fit Case Studies"
                        style={{ borderRadius: "12px" }}
                    />
                </a>
            </section>

            <section
                className="col-12 formSection bg-white webcast-vfit"
                id="aboutwebcast"
                name="aboutwebcast"
            >
                <div className="container innerForm">
                    <h2 className="sectionTitle3 font-weight-bold col-12 mx-auto">
                        About <span className="text-red">Vantage Fit</span>
                    </h2>
                    <p className="sub-para col-12 mx-auto text-center">
                        Take your corporate wellness program to a whole new
                        level with Vantage Fit, an AI Powered employee wellness
                        app with all the features to help you nurture a healthy
                        and engaged workforce.
                    </p>
                    <div className="col-12 d-flex align-items-center justify-content-center">
                        {" "}
                        <a
                            href="https://www.vantagefit.io/"
                            className="vfitcompanycta cta_b"
                        >
                            Explore more
                        </a>
                    </div>
                </div>
            </section>

            {/* <section
                id="speakers"
                name="speakers"
                className="webcast-vfit d-flex flex-column justify-content-center align-items-center  py-5 bg-light-yellow"
            >
                <div className="container">
                    <h2 className="col-12 sectionTitle-center font-weight-bold text-center pt-5">
                        Guest Speakers
                    </h2>
                    <div className="col-12 my-3 mt-lg-5">
                        <div className="row">
                            <div className="col-12 col-lg-4 my-lg-0 my-4 py-4 px-lg-5">
                                <div className="text-center">
                                    <img
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/w_250/v1679315465/VantageFit/2023/Ankit_Malhotra.webp"
                                        loading="lazy"
                                        alt="Ankit Malhotra"
                                    />
                                    <h3 className="mt-5">Ankit Malhotra</h3>
                                    <p className="sub-para text-center mt-0 f-400">
                                        CEO
                                        <br />
                                        Heyy
                                    </p>
                                    <p className="sub-para-1">
                                        Ankit is the founder of a mental
                                        health-tech startup -{" "}
                                        <span style={{ fontWeight: "600" }}>
                                            heyy
                                        </span>{" "}
                                        - that operates out of Singapore. Before
                                        this, Ankit led leadership roles in
                                        India & SEA across e-commerce & FMCG,
                                        namely Flipkart and Lazada.
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 my-lg-0 my-4 py-4 px-lg-5">
                                <div className="text-center">
                                    <img
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/w_250/v1679479914/VantageFit/2023/Anjan_Pathak.webp"
                                        loading="lazy"
                                        alt="Anjan Pathak"
                                    />
                                    <h3 className="mt-5">Anjan Pathak</h3>
                                    <p className="sub-para text-center mt-0 f-400">
                                        CTO & Co-founder
                                        <br />
                                        Vantage Circle
                                    </p>
                                    <p className="sub-para-1">
                                        As the CTO and Co-Founder of the
                                        company, Anjan Pathak is responsible for
                                        the technological progress and evolution
                                        of{" "}
                                        <span style={{ fontWeight: "600" }}>
                                            Vantage Circle
                                        </span>
                                        . As a wellness and fitness enthusiast
                                        and an athlete holding the prestigious
                                        "Iron Man" title, he spearheaded the
                                        development of Vantage Fit to promote
                                        total employee well-being across
                                        organizations.
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 my-lg-0 my-4 py-4 px-lg-5">
                                <div className="text-center">
                                    <img
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/w_250/v1679551508/VantageFit/2023/Alpa_Momaya.webp"
                                        loading="lazy"
                                        alt="Alpa Momaya"
                                    />
                                    <h3 className="mt-5">Alpa Momaya</h3>
                                    <p className="sub-para text-center mt-0 f-400">
                                        R&D Head, Nutrition
                                        <br />
                                        Healthifyme
                                    </p>
                                    <p className="sub-para-1">
                                        Specializing in Clinical Nutrition, Pre
                                        & Post Natal Diets, and Weight
                                        Management, Alpa Momaya works as R&D
                                        Head, Nutrition with{" "}
                                        <span style={{ fontWeight: "600" }}>
                                            Healthifyme
                                        </span>
                                        . Alpa has a great love for healthy
                                        cooking and is a Registered Nutritional
                                        Practitioner (Canada) with over 20 years
                                        of experience in the field.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section
                id="speakers"
                name="speakers"
                className="d-flex flex-column justify-content-center align-items-center  py-5 bg-light-yellow"
            >
                <div className="container">
                    <h2 className="col-12 sectionTitle-center font-weight-bold text-center pt-5">
                        Guest Speakers
                    </h2>
                    <div className="col-8 my-3 mt-lg-5 mx-auto">
                        <div className="row">
                            <div className="col-12 col-md-6 my-lg-0 my-4 py-4 px-lg-5">
                                <div className="text-center">
                                    <img
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/w_250/v1685091765/VantageFit/2023/Himanshu.png"
                                        loading="lazy"
                                        alt="Ankit Malhotra"
                                    />
                                    <h3 className="mt-5">Himanshu Ajay Jain</h3>
                                    <p className="sub-para text-center mt-0 f-400">
                                        Co-founder & Wellbeing Lead
                                        <br />
                                        MantraCare
                                    </p>
                                </div>
                                <ReadMoreContent
                                    text={speaker1Text}
                                    maxLength={212}
                                />
                            </div>
                            <div className="col-12 col-md-6 my-lg-0 my-4 py-4 px-lg-5">
                                <div className="text-center">
                                    <img
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/w_250/v1685091929/VantageFit/2023/Anjan.png"
                                        loading="lazy"
                                        alt="Anjan Pathak"
                                    />
                                    <h3 className="mt-5">Anjan Pathak</h3>
                                    <p className="sub-para text-center mt-0 f-400">
                                        CTO & Co-founder
                                        <br />
                                        Vantage Circle
                                    </p>
                                </div>
                                <ReadMoreContent
                                    text={anjanText}
                                    maxLength={208}
                                />
                            </div>
                            {/* <div className='col-12 col-lg-4 my-lg-0 my-4 py-4 px-lg-5'>
                            <div className='text-center'>
                                <img src='https://res.cloudinary.com/vantagecircle/image/upload/w_250/v1679551508/VantageFit/2023/Alpa_Momaya.png' loading='lazy' alt="Alpa Momaya"/>
                                <h3 className="mt-5">Alpa Momaya</h3>
                                <p className='sub-para text-center mt-0 f-400'>R&D Head, Nutrition<br/>Healthifyme</p>
                                <p className='sub-para-1'>Specializing in Clinical Nutrition, Pre & Post Natal Diets, and Weight Management, Alpa Momaya works as R&D Head, Nutrition with <span style={{'fontWeight': '600'}}>Healthifyme</span>. Alpa has a great love for healthy cooking and is a Registered Nutritional Practitioner (Canada) with over 20 years of experience in the field.</p>
                            </div>
                        </div> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default VantageFitWebcastLive;
